import React from 'react';
import Tab from './Tab';

export default class Tabs extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: this.props.children[0].props.label
		};
	}

	render() {
		const {
			onClickTabItem,
			props: { children, bottomBorder = 'border-b-1', menuWidth },
			state: { activeTab }
		} = this;

		let className = `border border-t-0 border-r-0 ${bottomBorder} border-l-0 ${menuWidth}`;

		return (
			<div className="tabs">
				<ol className={className}>
					{children.map((child) => {
						const {
							label,
							tabWidth,
							tabBgColor,
							isTextBold,
							isTabOutlined
						} = child.props;

						return (
							<Tab
								activeTab={activeTab}
								key={label}
								label={label}
								tabWidth={tabWidth}
								tabBgColor={tabBgColor}
								isTextBold={isTextBold}
								isTabOutlined={isTabOutlined}
								onClick={onClickTabItem}
							/>
						);
					})}
				</ol>
				<div className="tab-content">
					{children.map((child) => {
						if (child.props.label !== activeTab) return undefined;
						return child.props.children;
					})}
				</div>
			</div>
		);
	}

	onClickTabItem = (tab) => {
		this.setState({ activeTab: tab });
	};
}
